import { render, staticRenderFns } from "./SiteInfo.vue?vue&type=template&id=2d26da5c&scoped=true"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d26da5c",
  null
  
)

export default component.exports